import useTimelineData from "@src/utility_functions/customHooks/useTimelineData";

export const ExportRowMenu = (_props) => {
  const timelineDataContextObject = useTimelineData();
  const timelineDataFromContext = timelineDataContextObject?.timelineData ?? [];
  const timelineDataObject = timelineDataFromContext;

  const handleClick = () => {
    createAndDownloadJsonFile(timelineDataObject);
  };

  return (
    <>
      <div
        className={
          "_display--flex _justify-content--space-between _align-items--center"
        }
      >
        <p>This will download the current rows&apos; data as a JSON file.</p>
        <button
          className="_margin-left--2rem _padding--1rem_2rem _font-size--1rem _border-radius--4px _text-wrap--nowrap _background-color--var_blue-30_ _color--white _display--flex _justify-content--space-between _align-items--center _vertical-align--middle"
          onClick={() => {
            handleClick();
          }}
        >
          <i className="fa-regular fa-file-export _font-size--24px _margin-right--1rem"></i>
          <span className="_color--white _display--inline-block">
            Export Row
          </span>
        </button>
      </div>
    </>
  );
};

function createAndDownloadJsonFile(timelineDataObject: any[]) {
  if (!timelineDataObject || timelineDataObject.length === 0) return;

  const raw = timelineDataObject[0]?.data ?? timelineDataObject[0];
  if (!raw) return;

  let jsonObject: any;
  if (typeof raw === "string") {
    try {
      jsonObject = JSON.parse(raw);
    } catch {
      jsonObject = raw;
    }
  } else {
    jsonObject = raw;
  }

  const jsonContent = JSON.stringify(jsonObject, null, 2);
  const fileName =
    (timelineDataObject[0]?.label || "export") + "_timeline.json";
  const blob = new Blob([jsonContent], { type: "application/json" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  URL.revokeObjectURL(url);
  document.body.removeChild(a);
}
